export { default } from './GridTouristAgencies.vue'
